module.exports = __webpack_public_path__ + "static/lframe-instant-provisioning-b5ebe7ad649849b0465722cf9856854a.png";